import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		EdiProviderId: [],
	},
	edit: {
		ZaznamId: null as number | null,
		ProvozovnaId: null as number | null,
		EdiProviderId: null as number | null,
		EdiStorePath: null as string | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
